import { useQuery } from 'react-query'

import getCategory from '../services/getVideoCategory'

export default function useVideoCategory(categoryId) {
  const { isLoading, data: category } = useQuery(
    ['video_category', categoryId],
    () => getCategory(categoryId),
    {
      enabled: !!categoryId,
    }
  )

  return {
    isLoading,
    category,
  }
}
